import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuLabel, DropdownMenuSeparator } from '@/components/ui/dropdown-menu';
import { KeenIcon } from '@/components/keenicons';
export function DataGridColumnVisibility({
  table,
  hideTitle = false
}) {
  return <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="light" size="sm">
          <KeenIcon icon="setting-4" />
          {!hideTitle && 'Columns'}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[150px]">
        <DropdownMenuLabel className="font-medium">Toggle Columns</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {table.getAllColumns().filter(column => typeof column.accessorFn !== 'undefined' && column.getCanHide()).map(column => {
        return <DropdownMenuCheckboxItem key={column.id} className="capitalize" checked={column.getIsVisible()} onCheckedChange={value => column.toggleVisibility(!!value)}>
                {column.columnDef.meta?.headerTitle || column.id}
              </DropdownMenuCheckboxItem>;
      })}
      </DropdownMenuContent>
    </DropdownMenu>;
}

// import { Button } from "@/components/ui/button";
// import { DropdownMenu, DropdownMenuTrigger, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuLabel, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
// import { KeenIcon } from "@/components/keenicons";
// import { useEffect, useMemo, useState } from "react";

// export function DataGridColumnVisibility({ table, defaultColumns = [], hideTitle = false }) {
//   // ✅ Extract all available columns
//   const allColumns = useMemo(() => table.getAllColumns().filter(col => typeof col.accessorFn !== "undefined" && col.getCanHide()), [table]);

//   // ✅ State to track visible columns
//   const [visibleColumns, setVisibleColumns] = useState(new Set(defaultColumns));

//   // ✅ Apply visibility settings when table loads
//   useEffect(() => {
//     allColumns.forEach(column => {
//       column.toggleVisibility(defaultColumns.includes(column.id));
//     });
//   }, [allColumns, defaultColumns]);

//   // ✅ Handle column toggle
//   const toggleColumn = (column, value) => {
//     setVisibleColumns(prev => {
//       const newSet = new Set(prev);
//       value ? newSet.add(column.id) : newSet.delete(column.id);
//       column.toggleVisibility(!!value);
//       return newSet;
//     });
//   };

//   return (
//     <DropdownMenu>
//       <DropdownMenuTrigger asChild>
//         <Button variant="light" size="sm">
//           <KeenIcon icon="setting-4" />
//           {!hideTitle && "Columns"}
//         </Button>
//       </DropdownMenuTrigger>
//       <DropdownMenuContent align="end" className="w-[150px]">
//         <DropdownMenuLabel className="font-medium">Toggle Columns</DropdownMenuLabel>
//         <DropdownMenuSeparator />
//         {allColumns.map(column => (
//           <DropdownMenuCheckboxItem
//             key={column.id}
//             className="capitalize"
//             checked={visibleColumns.has(column.id)}
//             onCheckedChange={value => toggleColumn(column, value)}
//           >
//             {column.columnDef.meta?.headerTitle || column.id}
//           </DropdownMenuCheckboxItem>
//         ))}
//       </DropdownMenuContent>
//     </DropdownMenu>
//   );
// }